<template lang="html">

    <section class="banner-conectados">

        <div class="background">

            <div class="container">

                
                <div class="texto column-start">
                    
                    <p>Tu experencia, trayectoria profesional, conocimientos del sector en el que trabajas... son muy valiosos para quienes comienzan.</p>
                    <p>¿Quieres apoyar a los jovenes talentos?</p>
                    <div>
                    <router-link to="/" class="btn -skull -white">Conecta</router-link>
                    </div>
                    
                </div>
                
            </div>
        </div>

    </section>
  
  </template>
  
  <script lang="js">
    export default  {
      name: 'banner-conectados',
  }
  </script>
  
  <style scoped lang="scss">
    .error-404 {
  
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/parts/banner-conectados.vue